var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('df-item',{attrs:{"formitem":_vm.formitem}},[_c('a-upload',{attrs:{"name":_vm.formitem.key,"action":"/upload.do"}},[_c('a-button',[_c('a-icon',{attrs:{"type":"upload"}}),_vm._v(" 上传文件 ")],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }